/**
 * API fields like `message` may be a plain string or a nested object
 * `{ message: "...", status, errorcode, data }`. Returns a non-empty string or null.
 */
export function formatApiMessage(value, depth = 0) {
  if (value == null || depth > 8) return null;
  if (typeof value === "string") {
    const t = value.trim();
    return t !== "" ? t : null;
  }
  if (typeof value === "object") {
    if (Array.isArray(value)) return null;
    if (Object.prototype.hasOwnProperty.call(value, "message")) {
      const inner = formatApiMessage(value.message, depth + 1);
      if (inner) return inner;
    }
    if (typeof value.error === "string") {
      const t = value.error.trim();
      if (t !== "") return t;
    }
    if (typeof value.detail === "string") {
      const t = value.detail.trim();
      if (t !== "") return t;
    }
    return null;
  }
  const s = String(value).trim();
  return s !== "" ? s : null;
}
